export default function ErrorMessages({ errors }) {
  if (errors.length === 0) return null;

  const text = errors.join(", ");

  return <div className="peer text-red-600">{text}</div>;
}
